import {Spinner} from 'ngx-spinner/lib/ngx-spinner.enum';

export const constants = {
  CINETEL_USER: 'CINETEL_CASSE_USER',
  CINETEL_TOKEN: 'CINETEL_CASSE_TOKEN',
  CINETEL_TOKEN_REFRESH: 'CINETEL_CASSE_TOKEN_REFRESH',
  LANG_KEY: 'it',
  PROCEDURE_INTERVAL: 5000,
};

export const spinnersOptions: Spinner = {
  type: 'ball-triangle-path',
  size: 'medium',
  bdColor: 'rgba(0, 0, 0, 0.8)',
  color: '#fff',
  fullScreen: true
}

export enum userRole {
  A = 'A',
  C = 'C',
  D = 'D',
  E = 'E',
}

export const userRoleNames = {
  [userRole.A]: 'users.roles.administrator',
  [userRole.C]: 'users.roles.cashCounter',
  [userRole.D]: 'users.roles.distributor',
  [userRole.E]: 'users.roles.customer',
}

export const userRoles = [
  {
    value: userRole.A,
    name: userRoleNames[userRole.A],
  },
  {
    value: userRole.C,
    name: userRoleNames[userRole.C],
  },
  {
    value: userRole.D,
    name: userRoleNames[userRole.D],
  },
  {
    value: userRole.E,
    name: userRoleNames[userRole.E],
  }
]
